import { formatFileSize } from 'helpers/number';
import { dateToString, dateToday } from 'helpers/date';

export default {
  messages: {
    _default: field => `The ${field} value is not valid.`,
    after: (field, [target, inclusion]) =>
      `The ${field} must be after ${inclusion ? 'or equal to ' : ''}${target}.`,
    alpha_dash: field =>
      `The ${field} field may contain alpha-numeric characters as well as dashes and underscores.`,
    alpha_num: field => `The ${field} field may only contain alpha-numeric characters.`,
    alpha_spaces: field =>
      `The ${field} field may only contain alphabetic characters as well as spaces.`,
    alpha: field => `The ${field} field may only contain alphabetic characters.`,
    before: (field, [target, inclusion]) =>
      `The ${field} must be before ${inclusion ? 'or equal to ' : ''}${target}.`,
    between: (field, [min, max]) => `The ${field} field must be between ${min} and ${max}.`,
    confirmed: field => `The ${field} confirmation does not match.`,
    credit_card: field => `The ${field} field is invalid.`,
    date_between: (field, [min, max]) => `The ${field} must be between ${min} and ${max}.`,
    date_format: (field, [format]) => `The ${field} must be in the format ${format}.`,
    decimal: (field, [decimals = '*'] = []) =>
      `The ${field} field must be numeric and may contain ${
        !decimals || decimals === '*' ? '' : decimals
      } decimal points.`,
    digits: (field, [length]) =>
      `The ${field} field must be numeric and exactly contain ${length} digits.`,
    dimensions: (field, [width, height]) =>
      `The ${field} field must be ${width} pixels by ${height} pixels.`,
    email: field => `The ${field} field must be a valid email.`,
    ext: field => `The ${field} field must be a valid file.`,
    image: field => `The ${field} field must be an image.`,
    in: field => `The ${field} field must be a valid value.`,
    integer: field => `The ${field} field must be an integer.`,
    ip: field => `The ${field} field must be a valid ip address.`,
    length: (field, [length, max]) => {
      if (max) {
        return `The ${field} length be between ${length} and ${max}.`;
      }

      return `The ${field} length must be ${length}.`;
    },
    max: (field, [length]) => `The ${field} field may not be greater than ${length} characters.`,
    max_value: (field, [max]) => `The ${field} field must be ${max} or less.`,
    mimes: field => `The ${field} field must have a valid file type.`,
    min: (field, [length]) => `The ${field} field must be at least ${length} characters.`,
    min_value: (field, [min]) => `The ${field} field must be ${min} or more.`,
    not_in: field => `The ${field} field must be a valid value.`,
    numeric: field => `The ${field} field may only contain numeric characters.`,
    regex: field => `The ${field} field format is invalid.`,
    required: field => `The ${field} field is required.`,
    size: (field, [size]) => `The ${field} size must be less than ${formatFileSize(size)}.`,
    url: field => `The ${field} field is not a valid URL.`,
    user_and_email: field => `The ${field} must be a valid user or email.`,
    phone: field => `The ${field} is not a valid phone number.`,
    zip_code: field => `The ${field} is not a valid zip code.`,
    dni: field => `The ${field} is not a valid DNI.`,
    nie: field => `The ${field} is not a valid NIE.`,
    client_age_ge: (field, [ageThreshold]) =>
      `The client must be of age equal to or greater than${ageThreshold}`,
    client_age_between: (field, [ageMin, ageMax]) =>
      `The client must be between ${ageMin} and ${ageMax} years old.`,
    license_age_ge: (field, [minAges]) =>
      `The issue date must be equal to or greater than ${minAges} years`,
    today_or_above_90: field =>
      `The field ${field} must have a value between ${dateToString(dateToday())} and ${dateToString(
        dateToday()
          .clone()
          .add(90, 'days')
      )}`,
    file_count: (field, [min, max]) => {
      if (max) {
        return `The ${field} must contain between ${min} and ${max} files.`;
      }
      return `The ${field} must contain ${min} files.`;
    },
    required_file: field => `The ${field} is required.`
  }
};
